import { alpha, makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    position: "relative",
  },
  releaseSection: {
    backgroundColor: alpha(theme.custom.color.gainsboro, 0.4),
    padding: theme.spacing(1.5, 2.5),
    margin: theme.spacing(3, 0, 0, 0),
    display: "flex",
    position: "relative",
  },
  sectionOne: {
    fontSize: 48,
    display: "flex",
    alignItems: "center",
  },
  versionNumber: {
    paddingLeft: theme.spacing(1.5),
    fontWeight: "bold",
  },
  sectionTwo: {
    display: "flex",
    justifyContent: "space-around",
    width: "100%",
    marginLeft: theme.spacing(8),
  },
  subSection: {
    position: "relative",
    padding: theme.spacing(1.25, 3, 1.25, 0),
    display: "flex",
    flexDirection: "column",
  },
  subheading: {
    marginBottom: theme.spacing(0),
    fontSize: 12,
    textTransform: "uppercase",
    color: theme.custom.color.mortar,
    fontWeight: 600,
    display: "flex",
    alignItems: "center",
  },
  infoicon: {
    "& .MuiSvgIcon-root": {
      fontSize: 18,
      marginLeft: theme.spacing(1),
      color: theme.custom.color.pewter,
      display: "flex",
    },
  },
  font: {
    fontSize: 18,
    color: theme.custom.color.black,
    margin: theme.spacing(1, 0.5, 0, 0),
  },
  align: {
    margin: theme.spacing(0.5, 0, 0, 0),
  },
  alignMarginBottom: {
    margin: theme.spacing(1, 1, 0, 0),
  },
  alignMarginTop: {
    margin: theme.spacing(1, 0, 0, 0),
  },
}));
